var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "var(--primary-700)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4782 17.125H18.5217C17.2048 17.125 15.9628 17.7383 15.162 18.7837L12.7729 21.9036C11.5761 23.4663 11.7912 25.6882 13.2653 26.9922L25.7672 38.0517C27.0421 39.1796 28.9579 39.1796 30.2328 38.0517L42.7345 26.9922C44.2088 25.6882 44.4237 23.4663 43.2272 21.9036L40.8378 18.7837C40.037 17.7383 38.795 17.125 37.4782 17.125Z",
    fill: "#FFB15C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8146 22.4375L22.8447 17.125H18.5217C17.2048 17.125 15.9628 17.7383 15.1621 18.7839L12.7729 21.9038C11.5761 23.4663 11.7912 25.6882 13.2653 26.9924L23.8532 36.3589L19.6052 27.0251C18.9343 25.551 19.0122 23.8442 19.8146 22.4375Z",
    fill: "#E69B5B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7852 24.677H43.9685C44.0952 23.7227 43.8557 22.7224 43.2285 21.9031L40.8391 18.7832C40.4187 18.2341 39.8757 17.8057 39.2649 17.5215L33.7852 24.677Z",
    fill: "#FFC885"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2148 24.6775H33.7825L27.9985 17.125L22.2148 24.6775Z",
    fill: "#FFDAAA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7363 17.5215C16.1255 17.8059 15.5825 18.2341 15.1621 18.7832L12.7729 21.9031C12.1455 22.7224 11.9062 23.7227 12.0327 24.677H22.2163L16.7363 17.5215Z",
    fill: "#FFC885"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0312 24.6777C12.1462 25.5437 12.5623 26.3723 13.2637 26.9929L25.7654 38.0525C26.1919 38.4297 26.6902 38.6804 27.2122 38.8054L22.2148 24.6777H12.0312Z",
    fill: "#E69B5B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9661 24.6777C43.8511 25.5437 43.4351 26.3723 42.7337 26.9929L30.2319 38.0525C29.8054 38.4297 29.3069 38.6804 28.7852 38.8054L33.7827 24.6777H43.9661Z",
    fill: "#E69B5B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6038 27.0254C19.2642 26.2795 19.1165 25.4736 19.1572 24.6777H12.0312C12.1462 25.5439 12.5623 26.3726 13.2637 26.9929L23.8523 36.3599L19.6038 27.0254Z",
    fill: "#E48E45"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1587 24.677C19.1987 23.8999 19.4182 23.1318 19.8147 22.4368L20.1074 21.9233L16.7363 17.5215C16.1255 17.8059 15.5825 18.2341 15.1621 18.7832L12.7729 21.9031C12.1455 22.7224 11.9062 23.7227 12.0327 24.677H19.1587Z",
    fill: "#FFB15C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.4f963d97ffa9a904e2c6820b2dd742bf.svg";
export { ForwardRef as ReactComponent };